var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlide6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 717,
    height: 376,
    viewBox: "0 0 717 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M717 0H0V375.23H717V0Z",
    fill: "#B4E8F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M656.354 375.229C659.939 363.757 661.911 351.568 661.911 338.901C661.911 283.692 624.926 237.087 574.317 222.568C577.902 213.904 579.874 204.404 579.874 194.426C579.874 153.676 546.832 120.634 506.083 120.634C499.092 120.634 492.281 121.59 485.887 123.443C458.582 79.5264 409.945 50.3086 354.437 50.3086C282.678 50.3086 222.33 99.1841 204.883 165.447C121.711 168.016 55.0898 236.251 55.0898 320.02C55.0898 339.499 58.6748 358.081 65.2473 375.229H656.354Z",
    fill: "#5BC5DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M401.985 278.811C379.165 278.811 359.948 294.081 354 315.014H450.027C444.022 294.081 424.805 278.811 401.985 278.811Z",
    fill: "#39AECB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M532.958 278.811C510.138 278.811 490.921 294.081 484.973 315.014H581C574.995 294.081 555.778 278.811 532.958 278.811Z",
    fill: "#39AECB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M470.559 263.312C437.959 263.312 410.506 285.16 401.984 315.015H539.134C530.612 285.16 503.102 263.312 470.559 263.312Z",
    fill: "#39AECB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.525 262.543C79.4675 262.543 50.7875 285.367 41.8848 316.557H185.225C176.262 285.367 147.583 262.543 113.525 262.543Z",
    fill: "#0383A4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M309.027 262.543C274.969 262.543 246.289 285.367 237.387 316.557H380.727C371.764 285.367 343.084 262.543 309.027 262.543Z",
    fill: "#0383A4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M215.877 239.359C167.241 239.359 126.252 271.983 113.525 316.497H318.229C305.502 271.983 264.514 239.359 215.877 239.359Z",
    fill: "#0383A4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M525.441 333.524H191.558C185.404 333.524 180.385 328.505 180.385 322.351C180.385 316.197 185.404 311.178 191.558 311.178H525.381C531.536 311.178 536.555 316.197 536.555 322.351C536.614 328.565 531.595 333.524 525.441 333.524Z",
    fill: "#1698B8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M502.995 114.083V288.075C502.995 293.094 498.932 297.157 493.913 297.157H223.186C218.167 297.157 214.104 293.094 214.104 288.075V114.083C214.104 109.064 218.167 105.001 223.186 105.001H493.913C498.932 104.941 502.995 109.064 502.995 114.083Z",
    fill: "#00365D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 114,
    width: 271.03,
    height: 174.23,
    fill: "#DBF0F7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M473 126H404V207H473V126Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M460.031 138H416V144H460.031V138Z",
    fill: "#1698B8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M460.031 150H416V153H460.031V150Z",
    fill: "#39AECB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M460.031 171H416V174H460.031V171Z",
    fill: "#39AECB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M460.031 157H416V160H460.031V157Z",
    fill: "#39AECB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M460.031 178H416V181H460.031V178Z",
    fill: "#39AECB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M460.031 164H416V167H460.031V164Z",
    fill: "#39AECB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M460.031 185H416V188H460.031V185Z",
    fill: "#39AECB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M439 192H416V195H439V192Z",
    fill: "#39AECB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M393 219H324V288.25H393V219Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M380.031 231H336V237H380.031V231Z",
    fill: "#1698B8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M380.031 243H336V246H380.031V243Z",
    fill: "#39AECB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M380.031 264H336V267H380.031V264Z",
    fill: "#39AECB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M380.031 250H336V253H380.031V250Z",
    fill: "#39AECB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M380.031 271H336V274H380.031V271Z",
    fill: "#39AECB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M380.031 257H336V260H380.031V257Z",
    fill: "#39AECB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M380.031 278H336V281H380.031V278Z",
    fill: "#39AECB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M359 285H336V288H359V285Z",
    fill: "#39AECB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M393 126H324V207H393V126Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M380.031 138H336V144H380.031V138Z",
    fill: "#1698B8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M380.031 150H336V153H380.031V150Z",
    fill: "#39AECB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M380.031 171H336V174H380.031V171Z",
    fill: "#39AECB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M380.031 157H336V160H380.031V157Z",
    fill: "#39AECB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M380.031 178H336V181H380.031V178Z",
    fill: "#39AECB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M380.031 164H336V167H380.031V164Z",
    fill: "#39AECB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M380.031 185H336V188H380.031V185Z",
    fill: "#39AECB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M350 192H336V195H350V192Z",
    fill: "#39AECB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M313 219H244V288.25H313V219Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M300.031 231H256V237H300.031V231Z",
    fill: "#1698B8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M300.031 243H256V246H300.031V243Z",
    fill: "#39AECB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M300.031 264H256V267H300.031V264Z",
    fill: "#39AECB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M300.031 250H256V253H300.031V250Z",
    fill: "#39AECB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M300.031 271H256V274H300.031V271Z",
    fill: "#39AECB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M300.031 257H256V260H300.031V257Z",
    fill: "#39AECB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M300.031 278H256V281H300.031V278Z",
    fill: "#39AECB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M270 285H256V288H270V285Z",
    fill: "#39AECB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M313 126H244V207H313V126Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M300.031 138H256V144H300.031V138Z",
    fill: "#1698B8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M300.031 150H256V153H300.031V150Z",
    fill: "#39AECB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M300.031 171H256V174H300.031V171Z",
    fill: "#39AECB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M300.031 157H256V160H300.031V157Z",
    fill: "#39AECB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M300.031 178H256V181H300.031V178Z",
    fill: "#39AECB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M300.031 164H256V167H300.031V164Z",
    fill: "#39AECB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M300.031 185H256V188H300.031V185Z",
    fill: "#39AECB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M292 192H256V195H292V192Z",
    fill: "#39AECB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M473 219H404V288.25H473V219Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M460.031 231H416V237H460.031V231Z",
    fill: "#1698B8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M460.031 243H416V246H460.031V243Z",
    fill: "#39AECB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M460.031 264H416V267H460.031V264Z",
    fill: "#39AECB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M460.031 250H416V253H460.031V250Z",
    fill: "#39AECB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M460.031 271H416V274H460.031V271Z",
    fill: "#39AECB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M460.031 257H416V260H460.031V257Z",
    fill: "#39AECB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M460.031 278H416V281H460.031V278Z",
    fill: "#39AECB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M452 285H416V288H452V285Z",
    fill: "#39AECB"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M511.48 318.666H205.56C200.302 318.666 196 314.364 196 309.106V297.515H521.04V309.106C521.04 314.424 516.738 318.666 511.48 318.666Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M393.951 308.09H323.087C317.232 308.09 312.512 303.37 312.512 297.515H404.527C404.527 303.37 399.806 308.09 393.951 308.09Z",
    fill: "#066F90"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0268 59.2129C48.5168 59.2129 30.3528 73.6724 24.7363 93.3899H115.317C109.701 73.6724 91.5368 59.2129 70.0268 59.2129Z",
    fill: "#FEF6F4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M193.65 59.2129C172.14 59.2129 153.976 73.6724 148.359 93.3899H239C233.324 73.6724 215.16 59.2129 193.65 59.2129Z",
    fill: "#FEF6F4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M134.736 44.6328C103.964 44.6328 78.0329 65.2466 70.0264 93.4486H199.505C191.438 65.2466 165.507 44.6328 134.736 44.6328Z",
    fill: "#FEF6F4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2571 88.4902C63.9329 88.4902 52.7596 97.393 49.2344 109.582H105.22C101.814 97.4527 90.5814 88.4902 77.2571 88.4902Z",
    fill: "#DBF0F7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M153.617 88.4902C140.293 88.4902 129.12 97.393 125.595 109.582H181.64C178.175 97.4527 166.942 88.4902 153.617 88.4902Z",
    fill: "#DBF0F7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M117.23 79.4688C98.2291 79.4688 82.2161 92.1955 77.2568 109.643H157.202C152.303 92.1955 136.23 79.4688 117.23 79.4688Z",
    fill: "#DBF0F7"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M542.231 166.105C524.545 166.105 509.608 177.996 504.947 194.188H579.456C574.915 177.996 559.977 166.105 542.231 166.105Z",
    fill: "#F1F9FC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M643.926 166.105C626.24 166.105 611.302 177.996 606.642 194.188H681.15C676.549 177.996 661.612 166.105 643.926 166.105Z",
    fill: "#F1F9FC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M595.469 154.096C570.194 154.096 548.864 171.065 542.231 194.248H648.706C642.074 171.005 620.743 154.096 595.469 154.096Z",
    fill: "#F1F9FC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M510.623 61.3027C497.299 61.3027 486.126 70.2055 482.601 82.3945H538.586C535.121 70.2055 523.888 61.3027 510.623 61.3027Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M586.984 61.3027C573.659 61.3027 562.486 70.2055 558.961 82.3945H614.947C611.481 70.2055 600.308 61.3027 586.984 61.3027Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M550.596 52.2812C531.595 52.2812 515.582 65.008 510.623 82.455H590.569C585.609 65.008 569.596 52.2812 550.596 52.2812Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M583.936 78.6328C573.958 78.6328 565.474 85.3248 562.904 94.5263H605.028C602.399 85.3846 593.974 78.6328 583.936 78.6328Z",
    fill: "#F1F9FC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M641.416 78.6328C631.438 78.6328 622.953 85.3248 620.384 94.5263H662.508C659.819 85.3846 651.394 78.6328 641.416 78.6328Z",
    fill: "#F1F9FC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M614.05 71.8809C599.77 71.8809 587.701 81.4409 583.996 94.5859H644.105C640.34 81.4409 628.331 71.8809 614.05 71.8809Z",
    fill: "#F1F9FC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.111 246.408C542.804 246.408 543.365 246.97 543.365 247.662V330.774C543.365 331.467 542.804 332.029 542.111 332.029C541.419 332.029 540.857 331.467 540.857 330.774V247.662C540.857 246.97 541.419 246.408 542.111 246.408Z",
    fill: "#0383A4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M551.841 259.026C552.331 259.515 552.331 260.309 551.841 260.799L542.998 269.642C542.508 270.132 541.714 270.132 541.225 269.642C540.735 269.152 540.735 268.358 541.225 267.868L550.068 259.026C550.557 258.536 551.351 258.536 551.841 259.026Z",
    fill: "#0383A4"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M551.841 289.498C552.331 289.988 552.331 290.782 551.841 291.272L542.998 300.115C542.508 300.604 541.714 300.604 541.225 300.115C540.735 299.625 540.735 298.831 541.225 298.341L550.068 289.498C550.557 289.008 551.351 289.008 551.841 289.498Z",
    fill: "#0383A4"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.086 268.044C532.577 267.556 533.371 267.559 533.859 268.05L543.001 277.251C543.489 277.743 543.487 278.537 542.995 279.025C542.504 279.513 541.71 279.51 541.222 279.019L532.08 269.818C531.592 269.326 531.595 268.532 532.086 268.044Z",
    fill: "#0383A4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M542.111 234.039V261.285C542.111 261.285 547.788 255.191 547.788 247.662C547.788 240.134 542.111 234.039 542.111 234.039Z",
    fill: "#F87895"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M536.436 247.662C536.436 255.191 542.112 261.285 542.112 261.285V234.039C542.112 234.039 536.436 240.134 536.436 247.662Z",
    fill: "#FD9CAE"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M564.518 246.408L547.788 263.138C547.788 263.138 555.018 262.899 559.619 258.239C564.279 253.638 564.518 246.408 564.518 246.408Z",
    fill: "#F87895"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M552.688 251.308C548.087 255.908 547.788 263.138 547.788 263.138L564.518 246.408C564.518 246.408 557.288 246.647 552.688 251.308Z",
    fill: "#FD9CAE"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M564.518 276.82L547.788 293.55C547.788 293.55 555.018 293.311 559.619 288.651C564.279 284.05 564.518 276.82 564.518 276.82Z",
    fill: "#F87895"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M552.688 281.661C548.087 286.262 547.788 293.492 547.788 293.492L564.518 276.762C564.518 276.821 557.288 277.06 552.688 281.661Z",
    fill: "#FD9CAE"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M534.882 270.904L519.228 255.25C519.228 255.25 519.467 262.002 523.769 266.304C528.13 270.666 534.882 270.904 534.882 270.904Z",
    fill: "#FD9CAE"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M530.341 259.791C526.039 255.489 519.287 255.25 519.287 255.25L534.942 270.904C534.882 270.904 534.643 264.093 530.341 259.791Z",
    fill: "#F87895"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M651.146 240.981C651.635 241.47 651.635 242.264 651.146 242.754L592.352 301.548C591.862 302.038 591.068 302.038 590.578 301.548C590.089 301.058 590.089 300.264 590.578 299.775L649.372 240.981C649.862 240.491 650.656 240.491 651.146 240.981Z",
    fill: "#0383A4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M634.067 256.805C634.067 256.112 634.629 255.551 635.321 255.551H647.869C648.562 255.551 649.123 256.112 649.123 256.805C649.123 257.497 648.562 258.059 647.869 258.059H635.321C634.629 258.059 634.067 257.497 634.067 256.805Z",
    fill: "#0383A4"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M612.558 278.315C612.558 277.622 613.119 277.061 613.812 277.061H626.299C626.992 277.061 627.553 277.622 627.553 278.315C627.553 279.007 626.992 279.569 626.299 279.569H613.812C613.119 279.569 612.558 279.007 612.558 278.315Z",
    fill: "#0383A4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.749 249.217C629.442 249.217 630.003 249.778 630.003 250.471V263.437C630.003 264.129 629.442 264.691 628.749 264.691C628.057 264.691 627.495 264.129 627.495 263.437V250.471C627.495 249.778 628.057 249.217 628.749 249.217Z",
    fill: "#0383A4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M659.878 232.248L640.639 251.488C640.639 251.488 648.944 251.189 654.321 245.871C659.579 240.553 659.878 232.248 659.878 232.248Z",
    fill: "#F87895"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M646.255 237.863C640.937 243.181 640.639 251.546 640.639 251.546L659.878 232.307C659.878 232.247 651.573 232.546 646.255 237.863Z",
    fill: "#FD9CAE"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M666.989 256.865H643.328C643.328 256.865 648.646 261.824 655.159 261.824C661.671 261.824 666.989 256.865 666.989 256.865Z",
    fill: "#F87895"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M655.159 251.906C648.646 251.906 643.328 256.865 643.328 256.865H666.989C666.989 256.865 661.671 251.906 655.159 251.906Z",
    fill: "#FD9CAE"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M645.478 278.314H621.817C621.817 278.314 627.135 283.274 633.648 283.274C640.161 283.274 645.478 278.314 645.478 278.314Z",
    fill: "#F87895"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M633.648 273.416C627.135 273.416 621.817 278.375 621.817 278.375H645.478C645.478 278.316 640.22 273.416 633.648 273.416Z",
    fill: "#FD9CAE"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M628.749 253.16V231.053C628.749 231.053 624.148 236.012 624.148 242.106C624.088 248.201 628.749 253.16 628.749 253.16Z",
    fill: "#FD9CAE"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M633.35 242.106C633.35 236.012 628.749 231.053 628.749 231.053V253.16C628.749 253.16 633.35 248.201 633.35 242.106Z",
    fill: "#F87895"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.704 219.521C592.397 219.521 592.958 220.083 592.958 220.776V325.637C592.958 326.329 592.397 326.891 591.704 326.891C591.012 326.891 590.45 326.329 590.45 325.637V220.776C590.45 220.083 591.012 219.521 591.704 219.521Z",
    fill: "#0383A4"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M601.434 232.137C601.924 232.627 601.924 233.421 601.434 233.91L592.591 242.753C592.101 243.243 591.307 243.243 590.817 242.753C590.328 242.264 590.328 241.47 590.817 240.98L599.66 232.137C600.15 231.647 600.944 231.647 601.434 232.137Z",
    fill: "#0383A4"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M601.434 262.609C601.924 263.099 601.924 263.893 601.434 264.383L592.591 273.226C592.101 273.716 591.307 273.716 590.817 273.226C590.328 272.736 590.328 271.942 590.817 271.452L599.66 262.609C600.15 262.12 600.944 262.12 601.434 262.609Z",
    fill: "#0383A4"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.679 241.157C582.17 240.669 582.964 240.672 583.452 241.163L592.594 250.365C593.082 250.856 593.08 251.65 592.588 252.138C592.097 252.626 591.303 252.624 590.815 252.132L581.673 242.931C581.185 242.44 581.187 241.646 581.679 241.157Z",
    fill: "#0383A4"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M591.704 207.152V234.398C591.704 234.398 597.38 228.304 597.38 220.775C597.38 213.247 591.704 207.152 591.704 207.152Z",
    fill: "#F87895"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M586.028 220.775C586.028 228.304 591.705 234.398 591.705 234.398V207.152C591.705 207.152 586.028 213.247 586.028 220.775Z",
    fill: "#FD9CAE"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M614.111 219.52L597.381 236.25C597.381 236.25 604.611 236.011 609.211 231.35C613.872 226.749 614.111 219.52 614.111 219.52Z",
    fill: "#F87895"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M602.28 224.419C597.68 229.02 597.381 236.25 597.381 236.25L614.111 219.52C614.111 219.52 606.881 219.759 602.28 224.419Z",
    fill: "#FD9CAE"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M614.111 249.932L597.381 266.662C597.381 266.662 604.611 266.423 609.211 261.762C613.872 257.161 614.111 249.932 614.111 249.932Z",
    fill: "#F87895"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M602.28 254.773C597.68 259.373 597.381 266.603 597.381 266.603L614.111 249.873C614.111 249.933 606.881 250.172 602.28 254.773Z",
    fill: "#FD9CAE"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M584.475 244.018L568.82 228.363C568.82 228.363 569.059 235.115 573.361 239.417C577.723 243.779 584.475 244.018 584.475 244.018Z",
    fill: "#FD9CAE"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M579.934 232.904C575.632 228.602 568.88 228.363 568.88 228.363L584.534 244.018C584.475 244.018 584.236 237.206 579.934 232.904Z",
    fill: "#F87895"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M486.425 313.209C470.531 313.209 457.147 323.844 453.024 338.423H519.825C515.702 323.844 502.318 313.209 486.425 313.209Z",
    fill: "#066F90"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M577.603 313.209C561.71 313.209 548.326 323.844 544.203 338.423H611.004C606.881 323.844 593.497 313.209 577.603 313.209Z",
    fill: "#066F90"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M534.165 302.395C511.52 302.395 492.34 317.631 486.425 338.364H581.905C575.99 317.631 556.87 302.395 534.165 302.395Z",
    fill: "#066F90"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M489.652 312.373C489.711 312.313 489.771 312.254 489.831 312.194C490.189 311.596 490.01 310.82 489.413 310.461L481.705 305.621C481.107 305.263 480.331 305.442 479.972 306.04C479.614 306.637 479.793 307.414 480.39 307.772L488.098 312.612C488.576 312.911 489.233 312.791 489.652 312.373Z",
    fill: "#986738"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M489.532 310.042C489.532 310.042 492.46 311.715 491.982 312.373C491.504 313.03 483.975 321.455 483.557 321.096C482.123 320.021 487.261 312.193 488.038 311.656C488.755 311.118 489.114 309.803 489.532 310.042Z",
    fill: "#00365D"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M438.924 211.634C438.924 211.634 442.748 206.316 444.421 206.256C446.094 206.197 442.987 211.634 439.342 213.187L438.924 211.634Z",
    fill: "#986738"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M438.446 211.336C439.581 211.814 440.716 212.292 441.851 212.83C432.59 231.651 442.927 238.462 448.782 216.952C449.679 213.666 451.292 214.503 453.025 216.235C453.323 215.638 453.323 215.638 453.025 216.235C454.757 217.908 454.996 217.371 453.503 220.896C443.405 244.019 425.719 234.16 438.446 211.336Z",
    fill: "#066F90"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M450.933 325.578C450.993 325.578 451.112 325.578 451.172 325.578C451.829 325.459 452.307 324.742 452.188 324.085L450.395 315.122C450.276 314.465 449.559 313.987 448.901 314.106C448.244 314.226 447.766 314.943 447.886 315.6L449.678 324.563C449.798 325.22 450.335 325.578 450.933 325.578Z",
    fill: "#986738"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M448.125 320.379C449.499 320.32 450.814 320.2 452.188 320.021C448.185 298.511 445.137 269.652 455.892 249.576C452.606 247.962 449.32 246.409 446.034 244.855C438.147 262.362 444.839 301.917 448.125 320.379Z",
    fill: "#055C7F"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M484.095 311.477C484.991 310.401 485.827 309.266 486.664 308.131C462.166 291.7 453.742 276.165 458.82 246.11C455.176 245.453 451.471 244.975 447.767 244.438C448.663 279.451 457.028 290.923 484.095 311.477Z",
    fill: "#055C7F"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M452.487 323.906C452.487 323.906 453.264 327.192 452.487 327.252C451.711 327.371 440.418 327.67 440.358 327.132C440.119 325.34 449.38 323.667 450.277 323.846C451.173 324.085 452.368 323.428 452.487 323.906Z",
    fill: "#00365D"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M443.046 252.205C445.197 251.488 449.618 252.623 451.71 252.205C454.876 251.548 456.37 251.787 459.477 251.966C459.895 242.227 459.537 232.069 460.254 222.509C460.433 220.478 460.493 219.283 460.134 217.789C459.656 215.758 458.581 214.383 457.207 213.607C455.534 212.71 453.383 212.77 451.232 213.846C450.933 213.965 450.574 214.144 450.276 214.443C449.021 215.399 447.826 217.371 447.647 220.956C447.228 230.038 444.779 242.824 443.046 252.205Z",
    fill: "#066F90"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M450.336 214.502L450.515 220.596L450.754 228.244L453.921 221.134L457.267 213.665C455.594 212.769 453.443 212.829 451.292 213.904C450.993 214.024 450.635 214.263 450.336 214.502Z",
    fill: "#F1F9FC"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M456.789 207.752C454.697 210.978 450.754 212.113 448.782 210.859C446.81 209.604 447.587 206.377 449.678 203.151C451.77 199.924 454.458 199.327 456.37 200.641C458.342 201.836 458.88 204.525 456.789 207.752Z",
    fill: "#986738"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M457.505 209.781C457.027 210.558 455.653 210.976 455.115 210.677C454.578 210.319 454.817 209.602 455.295 208.885C455.773 208.108 456.669 207.749 457.207 208.048C457.804 208.407 458.043 209.064 457.505 209.781Z",
    fill: "#986738"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M456.311 207.213L452.308 206.795C452.248 207.333 451.83 212.591 452.009 214.562C452.129 215.16 453.144 215.459 454.22 215.16C455.176 214.921 455.893 214.323 455.953 213.786C455.893 212.65 456.132 209.125 456.311 207.213Z",
    fill: "#986738"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M454.818 208.885C454.22 208.228 453.682 208.825 452.248 209.602C450.814 210.379 448.305 210.2 448.126 206.854C448.006 204.703 446.811 208.228 446.811 208.228C446.572 209.961 447.05 211.036 448.185 211.753C449.798 212.829 452.368 212.649 454.638 211.275C455.057 210.439 455.236 209.303 454.818 208.885Z",
    fill: "#302004"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M458.581 206.018C458.581 206.018 459.238 203.508 458.103 201.716C456.968 199.923 453.801 198.011 451.232 200.461C451.232 200.461 449.618 202.313 452.008 204.106C454.458 205.898 454.757 204.225 455.295 206.257C455.832 208.229 457.565 207.93 457.625 208.348L458.581 206.018Z",
    fill: "#302004"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M450.515 220.597L450.754 228.245L453.92 221.135L453.801 216.475H452.427L450.515 220.597Z",
    fill: "#C0285C"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M476.626 252.861C476.626 252.861 476.089 259.733 477.343 260.868C478.598 262.063 479.853 255.61 478.001 251.846L476.626 252.861Z",
    fill: "#986738"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M475.909 253.757C476.924 253.518 477.94 253.219 478.956 252.921C473.937 235.952 472.563 230.813 460.732 217.549C458.94 215.517 458.342 215.756 456.789 217.549C456.37 217.429 456.37 217.369 456.789 217.549C455.235 219.281 455.594 219.759 457.506 221.731C470.352 234.816 468.858 237.386 475.909 253.757Z",
    fill: "#066F90"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M252.363 197.914C251.646 197.914 251.048 198.512 251.048 199.229V212.135H233.123C233.004 212.135 232.944 212.135 232.824 212.194V199.229C232.824 198.512 232.227 197.914 231.51 197.914C230.793 197.914 230.195 198.512 230.195 199.229V335.757C230.195 336.474 230.793 337.072 231.51 337.072C232.227 337.072 232.824 336.474 232.824 335.757V324.345C232.944 324.345 233.004 324.405 233.123 324.405H251.048V335.817C251.048 336.534 251.646 337.132 252.363 337.132C253.08 337.132 253.677 336.534 253.677 335.817V199.229C253.677 198.512 253.08 197.914 252.363 197.914ZM233.063 255.991H250.988V266.925H233.063C232.944 266.925 232.884 266.925 232.765 266.985V255.991C232.884 255.931 233.004 255.991 233.063 255.991ZM232.765 253.243V242.249C232.884 242.249 232.944 242.308 233.063 242.308H250.988V253.243H233.063C233.004 253.243 232.884 253.243 232.765 253.243ZM233.063 269.674H250.988V280.608H233.063C232.944 280.608 232.884 280.608 232.765 280.668V269.674C232.884 269.614 233.004 269.674 233.063 269.674ZM233.063 283.357H250.988V294.291H233.063C232.944 294.291 232.884 294.291 232.765 294.351V283.357C232.884 283.297 233.004 283.357 233.063 283.357ZM251.048 239.56H233.123C233.004 239.56 232.944 239.56 232.824 239.62V228.626C232.944 228.626 233.004 228.685 233.123 228.685H251.048V239.56ZM232.765 296.98C232.884 296.98 232.944 297.039 233.063 297.039H250.988V307.974H233.063C232.944 307.974 232.884 307.974 232.765 308.033V296.98ZM233.063 214.883H250.988V225.817H233.063C232.944 225.817 232.884 225.817 232.765 225.877V214.883C232.884 214.883 233.004 214.883 233.063 214.883ZM233.063 321.656C232.944 321.656 232.884 321.656 232.765 321.716V310.722C232.884 310.722 232.944 310.782 233.063 310.782H250.988V321.716H233.063V321.656Z",
    fill: "#066F90"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M208.626 273.913C208.567 273.913 208.447 273.853 208.387 273.793C207.79 273.435 207.611 272.718 207.969 272.12L212.331 264.532C212.689 263.934 213.406 263.755 214.004 264.114C214.601 264.472 214.781 265.189 214.422 265.787L210.06 273.375C209.762 273.853 209.164 274.092 208.626 273.913Z",
    fill: "#EFC2A6"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M208.268 271.106C208.268 271.106 205.579 272.839 206.057 273.436C206.535 274.034 214.183 281.682 214.541 281.383C215.856 280.308 210.538 273.078 209.821 272.6C209.104 272.122 208.626 270.807 208.268 271.106Z",
    fill: "#EC577F"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M273.634 170.906C273.634 170.906 278.713 167.262 280.266 167.68C281.76 168.098 277.338 172.101 273.574 172.46L273.634 170.906Z",
    fill: "#EFC2A6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M273.455 170.127C274.053 170.963 274.65 171.74 275.188 172.577C261.804 181.479 255.052 183.989 240.772 175.624C238.561 174.369 238.979 173.413 240.294 171.979C239.995 171.621 239.995 171.621 240.294 171.979C241.608 170.545 242.325 170.844 244.237 171.979C256.725 179.448 261.206 176.58 273.455 170.127Z",
    fill: "#C0285C"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M237.725 279.052C237.665 279.052 237.546 279.111 237.486 279.111C236.829 279.171 236.231 278.633 236.171 277.976L235.574 269.253C235.514 268.595 236.052 267.998 236.709 267.938C237.366 267.878 237.964 268.416 238.024 269.073L238.621 277.797C238.681 278.394 238.263 278.872 237.725 279.052Z",
    fill: "#EFC2A6"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M239.218 274.451C237.964 274.929 236.709 275.347 235.394 275.646C233.004 252.941 236.052 224.799 232.168 204.125C235.574 203.588 239.039 203.169 242.445 202.691C244.954 226.651 234.379 246.369 239.218 274.451Z",
    fill: "#055C7F"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M212.271 270.568C211.076 269.971 209.941 269.373 208.806 268.716C222.369 245.593 230.853 229.759 229.3 202.095C232.765 201.617 236.231 201.258 239.696 200.84C239.577 227.369 226.193 249.118 212.271 270.568Z",
    fill: "#055C7F"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M242.683 155.011C241.488 154.892 240.054 155.728 239.636 156.864C239.218 158.059 240.114 159.254 241.19 159.672C242.325 160.09 244.595 158.895 245.014 157.76C245.432 156.565 244.177 155.131 242.683 155.011Z",
    fill: "#1A0D01"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M238.442 162.958C236.291 161.225 232.467 160.867 230.137 162.54C227.806 164.213 227.926 167.738 229.539 169.949C231.152 172.159 236.052 173.534 239.756 171.263C242.146 169.769 241.131 165.169 238.442 162.958Z",
    fill: "#1A0D01"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M240.114 161.046C238.501 159.731 235.752 159.373 234.079 160.628C232.406 161.823 232.526 164.392 233.781 166.065C234.976 167.738 239.278 168.395 240.951 167.2C242.564 165.945 242.086 162.719 240.114 161.046Z",
    fill: "#1A0D01"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M237.546 163.197C239.099 166.543 242.684 168.156 244.716 167.2C246.747 166.244 246.448 163.077 244.895 159.791C243.341 156.505 240.892 155.549 238.86 156.505C236.829 157.401 235.992 159.91 237.546 163.197Z",
    fill: "#EFC2A6"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M236.589 165.049C236.948 165.825 238.202 166.483 238.74 166.184C239.278 165.945 239.158 165.228 238.8 164.451C238.441 163.674 237.665 163.137 237.067 163.435C236.529 163.734 236.231 164.272 236.589 165.049Z",
    fill: "#EFC2A6"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M236.052 161.345C236.052 161.345 235.753 158.895 237.067 157.342C238.382 155.788 241.668 154.414 243.7 157.043C243.7 157.043 245.014 159.015 242.445 160.389C239.876 161.763 239.816 160.15 239.039 162.002C238.262 163.795 236.709 163.317 236.53 163.675L236.052 161.345Z",
    fill: "#1A0D01"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M243.102 209.146C240.174 209.265 237.903 208.19 235.454 206.696C233.542 205.561 231.092 205.083 229.12 204.246C227.686 195.224 229.658 180.585 233.183 174.849C236.29 169.771 236.29 170.607 237.425 170.129C238.979 169.472 240.771 169.711 242.026 170.846L242.086 170.906C243.52 172.28 243.58 175.268 243.759 178.375C243.998 181.482 245.193 180.884 242.444 186.321C241.309 188.652 243.221 204.485 243.102 209.146Z",
    fill: "#EC577F"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M238.68 163.676L242.504 164.034C242.444 164.572 241.907 169.531 241.369 171.384C241.13 171.921 240.114 172.041 239.158 171.563C238.262 171.145 237.724 170.487 237.784 169.95C238.202 168.874 238.561 165.528 238.68 163.676Z",
    fill: "#EFC2A6"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M236.111 277.38C236.111 277.38 235.334 280.487 236.111 280.607C236.888 280.666 247.702 281.025 247.762 280.547C248.001 278.814 239.098 277.261 238.262 277.44C237.425 277.619 236.171 276.962 236.111 277.38Z",
    fill: "#EC577F"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M260.668 198.509C260.668 198.509 267.121 197.135 268.376 198.21C269.631 199.286 263.656 201.257 259.892 199.943L260.668 198.509Z",
    fill: "#EFC2A6"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M262.162 197.972C262.222 199.047 262.341 199.944 262.461 201.079C241.727 201.019 238.262 195.94 233.123 176.88C232.347 173.952 237.366 172.459 238.142 177.478C241.13 195.044 244.177 195.701 262.162 197.972Z",
    fill: "#C0285C"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.557 268.592C102.98 268.592 103.322 268.935 103.322 269.358V320.133C103.322 320.556 102.98 320.899 102.557 320.899C102.134 320.899 101.791 320.556 101.791 320.133V269.358C101.791 268.935 102.134 268.592 102.557 268.592Z",
    fill: "#00496F"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.458 276.268C108.759 276.565 108.762 277.05 108.465 277.351L103.102 282.783C102.805 283.084 102.32 283.087 102.019 282.79C101.718 282.493 101.715 282.008 102.012 281.707L107.375 276.275C107.672 275.974 108.157 275.971 108.458 276.268Z",
    fill: "#00496F"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.461 292.219C108.76 292.518 108.76 293.003 108.461 293.302L103.098 298.665C102.799 298.964 102.314 298.964 102.015 298.665C101.716 298.366 101.716 297.882 102.015 297.583L107.378 292.219C107.677 291.92 108.162 291.92 108.461 292.219Z",
    fill: "#00496F"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3703 281.846C96.6675 281.545 97.1523 281.542 97.4532 281.839L103.095 287.411C103.396 287.708 103.399 288.193 103.102 288.494C102.804 288.795 102.32 288.798 102.019 288.501L96.3771 282.929C96.0762 282.631 96.0732 282.147 96.3703 281.846Z",
    fill: "#00496F"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M102.558 261.069V277.716C102.558 277.716 106.04 274.024 106.04 269.427C106.04 264.761 102.558 261.069 102.558 261.069Z",
    fill: "#F87895"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0752 269.358C99.0752 273.955 102.558 277.647 102.558 277.647V261C102.558 261.07 99.0752 264.761 99.0752 269.358Z",
    fill: "#FD9CAE"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M116.208 268.592L105.97 278.83C105.97 278.83 110.358 278.691 113.213 275.835C116.069 272.98 116.208 268.592 116.208 268.592Z",
    fill: "#F87895"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M108.965 271.587C106.179 274.373 105.97 278.83 105.97 278.83L116.208 268.592C116.208 268.592 111.82 268.731 108.965 271.587Z",
    fill: "#FD9CAE"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M121.014 279.598L105.97 294.642C105.97 294.642 112.447 294.433 116.626 290.254C120.805 286.145 121.014 279.598 121.014 279.598Z",
    fill: "#F87895"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M110.427 283.985C106.248 288.164 106.039 294.641 106.039 294.641L121.084 279.597C121.014 279.597 114.536 279.875 110.427 283.985Z",
    fill: "#FD9CAE"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0998 283.568L88.5576 274.025C88.5576 274.025 88.6969 278.135 91.3437 280.782C93.9904 283.428 98.0998 283.568 98.0998 283.568Z",
    fill: "#FD9CAE"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3138 276.811C92.667 274.165 88.5576 274.025 88.5576 274.025L98.0998 283.568C98.0998 283.568 97.9605 279.389 95.3138 276.811Z",
    fill: "#F87895"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3703 297.099C96.6675 296.798 97.1523 296.795 97.4532 297.092L103.095 302.664C103.396 302.961 103.399 303.446 103.102 303.747C102.804 304.048 102.32 304.051 102.019 303.754L96.3771 298.182C96.0762 297.884 96.0732 297.4 96.3703 297.099Z",
    fill: "#00496F"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0992 298.821L84.7959 285.518C84.7959 285.518 85.0048 291.299 88.6963 294.92C92.3878 298.612 98.0992 298.821 98.0992 298.821Z",
    fill: "#FD9CAE"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2681 289.349C90.5766 285.657 84.8652 285.448 84.8652 285.448L98.1686 298.752C98.0989 298.821 97.89 293.04 94.2681 289.349Z",
    fill: "#F87895"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M93.363 312.336C84.169 312.336 76.4378 318.465 74 326.893H112.656C110.288 318.465 102.557 312.336 93.363 312.336Z",
    fill: "#066F90"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M146.158 312.336C136.964 312.336 129.233 318.465 126.795 326.893H165.451C163.083 318.465 155.352 312.336 146.158 312.336Z",
    fill: "#066F90"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M121.014 306.066C107.919 306.066 96.8449 314.842 93.3623 326.892H148.595C145.183 314.842 134.108 306.066 121.014 306.066Z",
    fill: "#066F90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide6);
export default __webpack_public_path__ + "static/media/slide6.81cf5ea21218a8adec2202a8bed04cf4.svg";
export { ForwardRef as ReactComponent };